import { Component, OnInit } from '@angular/core';
import { RailtracReportsService } from '../../railtrac-reports.service';
import { PageService } from '@bds/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
    selector: 'lib-rt-transit-time-rs-summary',
    templateUrl: './rt-transit-time-rs-summary.component.html',
    styleUrls: ['./rt-transit-time-rs-summary.component.css'],
})
export class RtTransitTimeRsSummaryComponent implements OnInit {
    public gridId = 112;
    public gridSource: any;
    public displayReport = false;
    public controlNames: string[] = ['Ship Begin Date', 'Ship End Date'];

    constructor(public reportService: RailtracReportsService, public pageService: PageService) {}

    ngOnInit(): void {
        this.pageService.setHeader('Transit Time By Route Segment Summary Report');
    }

    onGetReportClick(event: any): void {
        this.displayReport = true;
        this.gridSource = this.reportService.CreateAspNetDatastore(
            ReportConstants.ReportDataApiCall,
            this.gridId.toString(),
            event.startDate,
            event.endDate,
        );
    }

    onCancelClick(): void {
        this.displayReport = false;
    }
}
